import React, { useMemo } from 'react';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { SymbolFromConfigOrPortfolioLinkedStatus } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedStatus';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import classNames from 'classnames';
import ConfigSettingsModal from 'widgets/tiles/components/tile/ConfigSettingsModal';

import { usePortfolioStreamedOrSelectedSymbolFromOrders } from 'portfolio/store/hooks';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useVenueTypeCapsuleConfigSlice } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/store/config/configslice';
import { venueTypeCapsuleStreamedDataSelectors } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/store/stream/streamSlice';
import { getVenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import VenueTypeCapsuleSettings, {
    VenueTypeCapsuleSettingsText,
} from './settings/VenueTypeCapsuleSettings';
import { VenueTypeCapsuleContent } from './content/VenueTypeCapsuleContent';
import VenueTypeCapsuleChartHelp from 'widgets/venueAnalysis/capsules/venueTypeCapsule/components/VenueTypeCapsuleChartHelp';
import { useCapsuleBoundSymbol } from 'widgets/tiles/components/tile/hooks';

export function VenueTypeCapsule() {
    const { config, dispatchConfigChanged } = useVenueTypeCapsuleConfigSlice();

    const { useWidgetStreamData, useWidgetMessages } =
        venueTypeCapsuleStreamedDataSelectors;
    const streamData = useWidgetStreamData();
    const messages = useWidgetMessages();

    const data = getVenueAnalysisData(
        streamData,
        undefined,
        config.includePreviousDaysFills
    );

    const portfolioHasStreamedOrSelectedSymbol =
        !!usePortfolioStreamedOrSelectedSymbolFromOrders();

    const { symbol, linked } = useCapsuleBoundSymbol();

    const showOrderData = linked && portfolioHasStreamedOrSelectedSymbol;

    const { widgetKey } = useWidgetContext();

    useWidgetStream();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const warning = useMemo(() => <SymbolWarning />, [config]);

    const cssClasses = classNames('VenueTypeCapsule');

    return (
        <WidgetTile className={cssClasses}>
            <TileToolbar
                title="Fills By Venue Type"
                settingsBody={<VenueTypeCapsuleSettings />}
                settingsHeader={VenueTypeCapsuleSettingsText}
                settingsClassName="VenueTypeCapsuleSettingsModal"
                preceedingItems={<VenueTypeCapsuleChartHelp />}
                messages={symbol ? messages : []}
                wideTitle={true}
            />

            <div className="capsule-body">
                <SymbolFromConfigOrPortfolioLinkedStatus warning={warning}>
                    <VenueTypeCapsuleContent
                        data={data}
                        config={config}
                        dispatchConfigChanged={dispatchConfigChanged}
                        symbol={symbol}
                        capsuleKey={widgetKey}
                        showOrderData={showOrderData}
                    />
                </SymbolFromConfigOrPortfolioLinkedStatus>
            </div>
        </WidgetTile>
    );

    function SymbolWarning() {
        return (
            <span>
                Select a symbol or specify one in the&nbsp;
                <ConfigSettingsModal
                    dispatcher={dispatchConfigChanged}
                    headerText={VenueTypeCapsuleSettingsText}
                    triggerText={'Capsule Settings'}
                    renderSettings={(p) => <VenueTypeCapsuleSettings {...p} />}
                />
                .
            </span>
        );
    }
}
